<script>
  import { createEventDispatcher } from 'svelte';

  import Button from '@components/Button.svelte';
  export let mobile = false;
  const dispatch = createEventDispatcher();
  const dispatchClicked = () => {
    dispatch('clicked');
  };
</script>

<style style="text/scss" lang="scss">
  // Styles for desktop-based add button:
  .start-trending-bottom {
    position: fixed;
    bottom: 145px;
    display: flex;
    align-items: center;
    z-index: 4;
    left: calc(50% - 185px);
    &.mobile {
      left: calc(50% - 160px);
      bottom: 104px;
    }
  }
</style>

<div class="start-trending-bottom {mobile ? 'mobile' : ''}" style="display: flex">
  <span>
    <Button
      style="display: flex;
      border-radius: 12px;
background: #7A5CFA;
width: {mobile ? '320px' : '370px'};
height: 48px;
padding: 14px 24px;
justify-content: center;
align-items: center;
flex-shrink: 0;"
      text="<span style='margin-left: 10px; font-size: 18px;'>Next: start trending</span>"
      on:click={dispatchClicked} />
  </span>
</div>
